module.exports = __webpack_public_path__ + "static/media/textLogo2.bde75adc.png";